function queryStrings() {//get url querystring
    var params=document.location.search,reg=/(?:^\?|&)(.*?)=(.*?)(?=&|$)/g,temp,args={};
    while((temp=reg.exec(params)) !== null) args[temp[1]]=decodeURIComponent(temp[2]);
    return args;
}

function queryString(key){
    return (document.location.search.match(new RegExp("(?:^\\?|&)"+key+"=(.*?)(?=&|$)"))||['',null])[1];
}

function getStringByObject(obj){
  return Object.keys(obj).map(function(k) {
    return encodeURIComponent(k) + "=" + encodeURIComponent(obj[k]);
  }).join('&')
}

function getCurrentUrlByQuerys(querys){
  return window.location.origin + window.location.pathName +'?' + getStringByObject(querys)
}

function getQueryStringByStringUrl(url){
  if(!url) return {}
  url = decodeURIComponent(url)
  let sps = url.split('?')
  if(sps.length>1){
    let params = '?'+sps[1]
    let reg=/(?:^\?|&)(.*?)=(.*?)(?=&|$)/g,temp,args={};
    while((temp=reg.exec(params)) !== null) args[temp[1]]=decodeURIComponent(temp[2]);
    return args;
  }
  else{
    return {}
  }

}

export default {
  queryStrings,queryString,getStringByObject,getCurrentUrlByQuerys,getQueryStringByStringUrl
}
